(function () {
  var page = document.querySelector("[data-privacy-page]");
  if (!page) {
    return;
  }

  var content = page.querySelector("[data-privacy-content]");
  var tocList = page.querySelector("[data-privacy-toc-list]");
  var tocToggle = page.querySelector("[data-privacy-toc-toggle]");
  var printButton = page.querySelector("[data-privacy-print]");
  var backTop = page.querySelector("[data-privacy-back-top]");
  var copyLinksEnabled = page.getAttribute("data-privacy-copy-links") === "true";
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var activeLink = null;

  function getHeaderOffset() {
    var header = document.querySelector("#shopify-section-header, header[role='banner'], header");
    var height = 84;
    if (header) {
      height = Math.max(height, Math.ceil(header.getBoundingClientRect().height));
    }
    return height + 18;
  }

  function updateStickyOffset() {
    page.style.setProperty("--privacy-sticky-offset", getHeaderOffset() + "px");
  }

  function cleanText(value) {
    return (value || "").replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim();
  }

  function isParagraphHeading(element) {
    if (!element) {
      return false;
    }
    var text = cleanText(element.textContent);
    return /^§\s*\d{1,2}\b/.test(text) && text.length < 190;
  }

  function normalizeHeading(element) {
    if (!element || element.tagName.toLowerCase() === "h2") {
      return element;
    }

    var heading = document.createElement("h2");
    while (element.firstChild) {
      heading.appendChild(element.firstChild);
    }
    element.parentNode.replaceChild(heading, element);
    return heading;
  }

  function getParagraphHeadings() {
    if (!content) {
      return [];
    }

    var nodes = Array.prototype.slice.call(content.querySelectorAll("h2, p"));
    var headings = [];
    var used = {};

    nodes.forEach(function (node) {
      if (!isParagraphHeading(node)) {
        return;
      }

      var text = cleanText(node.textContent);
      var match = text.match(/^§\s*(\d{1,2})\b/);
      if (!match || used[match[1]]) {
        return;
      }

      var heading = normalizeHeading(node);
      heading.id = "polityka-prywatnosci-paragraf-" + match[1];
      heading.classList.add("privacy-paragraph-heading");
      headings.push({
        number: parseInt(match[1], 10),
        title: text,
        element: heading
      });
      used[match[1]] = true;
    });

    headings.sort(function (a, b) {
      return a.number - b.number;
    });

    return headings;
  }

  function scrollToElement(element, updateHash) {
    if (!element) {
      return;
    }

    var top = element.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 10;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: reduceMotion ? "auto" : "smooth"
    });

    if (updateHash && window.history && window.history.pushState) {
      window.history.pushState(null, "", "#" + element.id);
    }
  }

  function setActiveLink(id) {
    if (!tocList || activeLink && activeLink.getAttribute("href") === "#" + id) {
      return;
    }

    if (activeLink) {
      activeLink.classList.remove("is-active");
      activeLink.removeAttribute("aria-current");
    }

    activeLink = tocList.querySelector('a[href="#' + id + '"]');
    if (activeLink) {
      activeLink.classList.add("is-active");
      activeLink.setAttribute("aria-current", "location");
    }
  }

  function buildToc(headings) {
    if (!tocList) {
      return;
    }

    tocList.innerHTML = "";
    headings.forEach(function (heading) {
      var item = document.createElement("li");
      var link = document.createElement("a");
      link.href = "#" + heading.element.id;
      link.textContent = heading.title;
      link.addEventListener("click", function (event) {
        event.preventDefault();
        scrollToElement(heading.element, true);
        if (tocToggle) {
          tocToggle.setAttribute("aria-expanded", "false");
          page.classList.remove("privacy-page--toc-open");
        }
      });
      item.appendChild(link);
      tocList.appendChild(item);
    });
  }

  function addCopyLinks(headings) {
    if (!copyLinksEnabled || !navigator.clipboard) {
      return;
    }

    headings.forEach(function (heading) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "privacy-copy-link";
      button.setAttribute("aria-label", "Kopiuj link do " + heading.title);
      button.title = "Kopiuj link do paragrafu";
      button.innerHTML = '<span aria-hidden="true">#</span>';
      button.addEventListener("click", function () {
        var url = window.location.href.split("#")[0] + "#" + heading.element.id;
        navigator.clipboard.writeText(url).then(function () {
          button.classList.add("is-copied");
          window.setTimeout(function () {
            button.classList.remove("is-copied");
          }, 1400);
        });
      });
      heading.element.appendChild(button);
    });
  }

  function observeHeadings(headings) {
    if (!("IntersectionObserver" in window) || !headings.length) {
      if (headings[0]) {
        setActiveLink(headings[0].element.id);
      }
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setActiveLink(entry.target.id);
        }
      });
    }, {
      rootMargin: "-" + (getHeaderOffset() + 10) + "px 0px -62% 0px",
      threshold: 0
    });

    headings.forEach(function (heading) {
      observer.observe(heading.element);
    });
  }

  updateStickyOffset();
  window.addEventListener("resize", updateStickyOffset, { passive: true });

  var headings = getParagraphHeadings();
  buildToc(headings);
  addCopyLinks(headings);
  observeHeadings(headings);
  page.classList.add("privacy-page--ready");
  page.setAttribute("data-privacy-paragraph-count", String(headings.length));

  if (tocToggle) {
    tocToggle.addEventListener("click", function () {
      var expanded = tocToggle.getAttribute("aria-expanded") === "true";
      tocToggle.setAttribute("aria-expanded", String(!expanded));
      page.classList.toggle("privacy-page--toc-open", !expanded);
    });
  }

  var tocJump = page.querySelector('a[href="#privacy-toc"]');
  if (tocJump && tocToggle) {
    tocJump.addEventListener("click", function () {
      if (window.matchMedia("(max-width: 900px)").matches) {
        tocToggle.setAttribute("aria-expanded", "true");
        page.classList.add("privacy-page--toc-open");
      }
    });
  }

  if (printButton) {
    printButton.addEventListener("click", function () {
      window.print();
    });
  }

  if (backTop) {
    window.addEventListener("scroll", function () {
      backTop.hidden = window.pageYOffset < 760;
    }, { passive: true });

    backTop.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: reduceMotion ? "auto" : "smooth"
      });
    });
  }

  if (window.location.hash) {
    var target = document.getElementById(window.location.hash.slice(1));
    if (target) {
      window.setTimeout(function () {
        scrollToElement(target, false);
      }, 80);
    }
  }
})();
